import React from "react";

const Plus = props => (
  <svg viewBox="0 0 12 12" fill="none" {...props}>
    <path
      d="M11.75 5.25h-5v-5A.269.269 0 006.5 0h-1a.246.246 0 00-.25.25v5h-5A.246.246 0 000 5.5v1c0 .156.094.25.25.25h5v5c0 .156.094.25.25.25h1c.125 0 .25-.094.25-.25v-5h5c.125 0 .25-.094.25-.25v-1a.269.269 0 00-.25-.25z"
      fill="currentColor"
    />
  </svg>
);

export default Plus;
